<template>
    <div v-show="getVisibilityFooter" class="footer">
        <div class="footer-title">
            <h3>I'm currently looking for work</h3>
            <a href="https://www.linkedin.com/in/akash89/" target="_blank" class="linked-link">
                <img src="../assets/images/logo-linkedin.svg"/>
            </a>
        </div>
        <router-link :to="{ name: 'Contact' }">
            <h3 class="underline">Get in touch!</h3>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Footer',
    computed: {
        ...mapGetters(['getVisibilityFooter'])
    }
}
</script>

<style scoped>
.footer {
    background: var(--dark2);
    height: 100px;
    width: 100%;
    padding-top: 15px;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-flow: column;
    
}
.footer-title {
    align-self: center;
    position: relative;
}
h3 {
    text-align: center;
    color: white;
    margin: 0;
    margin-bottom: 10px;
    transition: all 0.5s;
    vertical-align: middle;
}
h3.underline:hover {
    color: var(--blue);
}
a.linked-link {
    position: absolute;
    right: -40px;
    top: -4px;
}
img {
    width: 35px;
}
</style>